import { Component, OnInit } from '@angular/core';
import { SeoService } from '../core/service/seo.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
  imports: [RouterLink],
})
export class ContactComponent implements OnInit {
  constructor(private seoService: SeoService) {}

  ngOnInit(): void {
    this.seoService.updateMetaTag(
      'description',
      'Kontaktieren Sie uns für Fragen, Anregungen, Anmelundgen oder Zusammenarbeit. ' + 'Unsere Kontaktdaten und Erreichbarkeiten finden Sie hier.',
    );
    this.seoService.createLinkForCanonicalURL('/contact');
  }
}
